import Image from 'next/image'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import ResponsiveDiv from 'components/common/ResponsiveDiv'

const VenderWhyChooseUs = ({ reasons, image }) => {
  const safeReasons = Array.isArray(reasons)
    ? reasons.filter((item) => item && typeof item === 'object')
    : []

  if (!safeReasons.length && !image?.url) return null

  return (
    <>
      <Box
        mb={18}
        display="flex"
        flexDirection={{ xs: 'column', md: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'stretch', md: 'center' }}
        gap={{ xs: 6, md: 12 }}
      >
        <Box display="flex" flexDirection="column" gap={6}>
          <ResponsiveDiv>
            <Typography variant="h5" color="text.minus1">
              選擇我們的理由
            </Typography>
          </ResponsiveDiv>
          {safeReasons.map((item, index) => (
            <Box key={index} display="flex" flexDirection="column" gap={4}>
              <Box display="flex" alignItems="flex-start" gap={1}>
                <img src="/img/lightbulb.svg" alt="" width={24} height={24} />
                <Typography
                  variant="titleLarge"
                  color="text.minus1"
                  sx={{
                    display: '-webkit-box',
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                  }}
                >
                  {item?.title}
                </Typography>
              </Box>

              {!!item?.description && (
                <Typography variant="paraBodySmall" color="text.secondary">
                  {item.description}
                </Typography>
              )}
            </Box>
          ))}
        </Box>

        {!!image?.url && (
          <Box
            flexShrink={0}
            position="relative"
            sx={{
              width: { xs: '100%', md: 'calc(40% - 48px)' },
              aspectRatio: '3/2',
              borderRadius: '24px',
              overflow: 'hidden',
              bgcolor: '#d9d9d9',
            }}
          >
            <Image
              src={image.url}
              fill
              style={{ objectFit: 'cover' }}
              alt="選擇我們的理由"
            />
          </Box>
        )}
      </Box>
    </>
  )
}

export default VenderWhyChooseUs
